import React, {useEffect, useRef, useState} from "react";
import {ReactComponent as CloseX} from '../assets/images/icons/closeX.svg';
import useParams from "../hooks/useParams";

const useFilters = (isMobile, setCurrentPage, filtersForRequest, parametersReady, expandedSubCategories, setExpandedSubCategories,
                    selectedTabOption, isFromListing =false, lang) => {
    const [showMobileFilter, setShowMobileFilter] = useState(false);
    const [expandedCategories, setExpandedCategories] = useState({});
    const filterRef = useRef(null); // Create a ref for the filter
    const [selectedOptions, setSelectedOptions] = useState({});
    const [filtersReady, setFiltersReady] = useState(false);
    const [filtersChanged, setFiltersChanged] = useState({});
    const [filters, setFilters] = useState(filtersForRequest ? filtersForRequest : []);
    const {categoryIdList,categoryNameList} = useParams();


    const syncFiltersFromURL = () => {
        const urlParams = new URLSearchParams(window.location.search);

        const newSelectedOptions = {};
        const newFiltersArray = [];

        urlParams.forEach((value, key) => {
            const values = value.split(',');

            newSelectedOptions[key] = values.map(v => ({
                category: v,
                displayName: v
            }));

            values.forEach(v => {
                newFiltersArray.push({
                    property: key,
                    value: v
                });
            });
        });

        setSelectedOptions(newSelectedOptions);
        setFiltersChanged(newSelectedOptions);
        setFilters(newFiltersArray);
        setFiltersReady(true);
        setCurrentPage(1);
    };

    useEffect(() => {
        // On initial mount, restore filters from URL
        syncFiltersFromURL();
    }, []);

    const redirectWithFilters = (currentURL) => {
        window.location.href = currentURL.toString();
    };


    const updateUrlWithFilters = (filterValue, filterCategory, action, isFromListing=false, shouldRedirect=false) => {
        const currentURL = new URL(window.location.href);
        const urlParams = new URLSearchParams(currentURL.search);

        if (urlParams.get('page')) {
            urlParams.set('page', '1');
        }
        if (action === 'removeAll') {
            // Remove all categories from the URL
            Object.keys(selectedOptions).forEach((category) => {
                urlParams.delete(category);
                if(isFromListing===false) {
                    setFiltersChanged({});
                }
            });
            if(isFromListing===true) {
                updateAndRedirect(currentURL, null, categoryNameList[categoryNameList.length-1], urlParams, true, categoryNameList)
            }
        } else if (action === 'removeAllFromCategory') {
            // Remove all filters from a specific category
            if (filterCategory) {
                urlParams.delete(filterCategory);
                setFiltersChanged((prevFilters) => {
                    const updatedFilters = { ...prevFilters };
                    delete updatedFilters[filterCategory];
                    return updatedFilters;
                });
            }
        } else if (isFromListing===true && filterCategory==='categoryPath'){
            //edw einai to check uncheck filtrou katigorias
            if (action ==='add'){
                updateAndRedirect(currentURL,filterValue,null,urlParams ,true)
            }else {
                updateAndRedirect(currentURL,null,filterValue,urlParams ,true)
            }

        } else {
            // Handle other actions: add, remove, replace
            const filterParams = urlParams.get(filterCategory);

            if (filterParams) {
                let filterParamsArray = filterParams.split(',');

                if (action === 'add') {
                    if (!filterParamsArray.includes(filterValue)) {
                        filterParamsArray.push(filterValue);
                    }
                } else if (action === 'remove') {
                    filterParamsArray = filterParamsArray.filter(param => param !== filterValue);
                } else if (action === 'replace') {
                    filterParamsArray = [filterValue];
                }

                // Update or remove the category
                if (filterParamsArray.length > 0) {
                    urlParams.set(filterCategory, filterParamsArray.join(','));
                } else {
                    urlParams.delete(filterCategory);
                }
            } else if (action === 'add') {
                urlParams.set(filterCategory, filterValue);
            }
        }

        currentURL.search = urlParams.toString();
        if(isFromListing === false) {
            window.history.pushState({}, '', currentURL);
        }
        setFiltersReady(true);
        if (shouldRedirect === true) {
            redirectWithFilters(currentURL);
        }
    };

    const toggleCategorySelection = (currentPathOrTitle, item, currentPath, isFromListing=false) => {
        if(!isArrowClicked && isFromListing===false) {
            handleFilterOptionChange(currentPath, item?.categoryId, currentPathOrTitle);

        }else if (isFromListing===true){
            handleFilterOptionChange(currentPathOrTitle, item?.categoryId, null, isFromListing);
        }
        setIsArrowClicked(false);
    }

    // Handle show and hide functionality for filter section
    const handleShowFilterSection = () => {
        if (isMobile) setShowMobileFilter(!showMobileFilter);
    };

    // Function to close the filter if clicked outside
    const handleClickOutside = (event) => {
        if (filterRef.current && !filterRef.current.contains(event.target)) {
            setShowMobileFilter(false); // Close the filter
        }
    };

    // Effect to add event listener for clicks outside
    useEffect(() => {
        if (showMobileFilter) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside); // Cleanup on unmount
        };
    }, [showMobileFilter]);

    // Function to disable body scroll when the filter is open
    useEffect(() => {
        if (showMobileFilter) {
            document.body.style.overflow = 'hidden';  // Disable scrolling on the body
        } else {
            document.body.style.overflow = '';  // Restore scrolling on the body
        }

        return () => {
            document.body.style.overflow = '';  // Clean up on component unmount
        };
    }, [showMobileFilter]);

    // Toggle the expansion state of a given category
    const toggleCategoryExpansion = (category) => {
        setExpandedCategories((prev) => ({
            ...prev,
            [category]: !prev[category],
        }));
    };

    const [isArrowClicked, setIsArrowClicked] = useState(false);

    // Toggle for subcategory
    const toggleSubCategoryExpansion = (category, subCategory) => {
        setExpandedSubCategories((prev) => ({
            ...prev,
            [subCategory]: !prev[subCategory],
        }));
        setIsArrowClicked(true);
    };

    // Component to display a selected filter item with a remove button.
    function SelectedItem({name, count, onRemove}) {
        return (
            <div className="selected-item">
                {name} ({count})
                <button className="remove-button" onClick={onRemove}>
                    <CloseX />
                </button>
            </div>
        );
    }

    const handleRemoveFilterOption = (category, value) => {
        if(category==='categoryPath' && isFromListing===true){
            updateUrlWithFilters(value, category, "remove", true, true);
        }else {
            if(category === 'availability'){
                value = lang == 'en' ? 'Yes' : 'Ναι';
            }
            updateUrlWithFilters(value, category, "remove", false, true);
            setFiltersChanged((prevState) => {
                const newState = { ...prevState };
                if (!newState[category]) return prevState;
                const filteredOptions = newState[category].filter(option => option.category !== value);
                if (filteredOptions.length === 0) {
                    delete newState[category];
                } else {
                    newState[category] = filteredOptions;
                }
                return newState;
            });
        }

    };


    // Handle changes to category checkboxes.
    const handleCheckboxChange = (category) => {
        setFiltersChanged((prevState) => {
            const currentCategory = prevState[category] || [];
            return {
                ...prevState,
                [category]: currentCategory.filter((item) => item !== category),
            };
        });
    };

    // Handle the removal of a selected filter item.
    const handleRemove = (itemNameToRemove) => {
        setFiltersChanged((prevState) => {
            const updatedState = {...prevState};
            for (let category in updatedState) {
                if (updatedState[category].includes(itemNameToRemove)) {
                    updatedState[category] = updatedState[category].filter((itemName) => itemName !== itemNameToRemove);
                    if (!updatedState[category].length) delete updatedState[category];
                    break;
                }
            }
            return updatedState;
        });
    };

    const handleFilterOptionChange = (category, parentCategory, childCategory, isFromListing=false, isAvailabilityFilterChanged= false) => {
        console.log('category',category);
        console.log('parentCategory',parentCategory);
        console.log('childCategory',childCategory);
        const isSelected = selectedOptions[parentCategory]?.some(option => option.category === (childCategory || category));


        const action = (isSelected || isAvailabilityFilterChanged) ? "remove" : "add";

        updateUrlWithFilters(childCategory || category, parentCategory, action, isFromListing, true);

        setFiltersChanged((prevState) => {
            const newState = { ...prevState };
            Object.keys(selectedOptions).forEach((key) => {
                newState[key] = [...(selectedOptions[key] || [])];
            });

            const currentCategory = newState[parentCategory] || [];
            const existingCategoryIndex = currentCategory.findIndex(option =>
                option.category === (childCategory || category)
            );

            if (action === "add") {
                if (existingCategoryIndex === -1) {
                    currentCategory.push({
                        category: childCategory || category,
                        displayName: category
                    });
                }
            } else if (action === "remove") {
                if (existingCategoryIndex !== -1) {
                    currentCategory.splice(existingCategoryIndex, 1);
                }
            }

            if (currentCategory.length > 0) {
                newState[parentCategory] = currentCategory;
            } else {
                delete newState[parentCategory];
            }
            return newState;
        });
    };

    const handleRadioFilterOptionChange = (category, parentCategory) => {
        const action = selectedOptions[parentCategory] != null ? "replace" : "add";
        updateUrlWithFilters(category, parentCategory, action, false, true);
        setFiltersChanged((prevState) => {
            const newState = { ...prevState };
            Object.keys(selectedOptions).forEach((key) => {
                newState[key] = [...(selectedOptions[key] || [])];
            });
            newState[parentCategory] = [{ category, displayName: category }];
            return newState;
        });
    };

    useEffect(() => {
        if (parametersReady) {
            setSelectedOptions(filtersChanged);
            const filtersArray = Object.entries(filtersChanged)
                .flatMap(([parentCategory, values]) =>
                    values.map(value => ({
                        property: parentCategory,
                        value: value.category
                    }))
                );
            setFilters(filtersArray);
            setCurrentPage(1);
        }
    }, [filtersChanged]); //kathe fora pou allazei kapoio filtro me check uncheck, settarontai filters gia to req

    useEffect(() => {
        if (parametersReady) {
            const newSelectedOptions = filtersForRequest.reduce((res, filter) => {
                const values = filter.value?.split(',') || [];
                values.forEach(value => {
                    const category = value.trim();
                    if (!res[filter.property]) {
                        res[filter.property] = [];
                    }
                    res[filter.property].push({
                        category: category,
                        displayName: category
                    });
                });
                return res;
            }, {});

            const transformedData = filtersForRequest.map(item => ({
                property: item.property,
                value: item.value?.split(',')
            }));
            setFilters(transformedData);
            setSelectedOptions(newSelectedOptions);
            setFiltersReady(true);
        }
    }, [filtersForRequest]); // tin prwti fora pou kanei render h selida

    // Reset all selected options
    const clearFilters = (categoryId) => {

        if(isFromListing===true){
            updateUrlWithFilters('',  '', 'removeAll', isFromListing);
        }else {
            updateUrlWithFilters('', categoryId ? categoryId : '', categoryId ? 'removeAllFromCategory' :'removeAll');
        }
    };

    // useEffect(() => {
    //     if(isFromListing===false){
    //         clearFilters();
    //     }
    // }, [selectedTabOption]); //den apasxolei tin listing


    const updateAndRedirect = (url, segmentToAdd = null, segmentToRemove = null, queryParams = {}, shouldRedirect = true, categoryNameList = null) => {

        // Update Pathname: Add or Remove Segment
        const paths = url.pathname.split("/").filter(path => path);
        if (segmentToRemove) {
            if (categoryNameList?.length !== 1) {
                url.pathname = paths.filter(path => path !== segmentToRemove).join("/");
            }
        }
        if (segmentToAdd) {
            url.pathname = [...paths, segmentToAdd].join("/");
        }

        url.search = queryParams.toString();
        const updatedUrl = url.toString();
        // Redirect if needed, uncommented because of redirection in local react
        if (shouldRedirect) {
            window.location.href = updatedUrl;
        }

    };


    return {
        handleShowFilterSection,
        SelectedItem,
        filterRef,
        showMobileFilter,
        setShowMobileFilter,
        expandedCategories,
        expandedSubCategories,
        toggleSubCategoryExpansion,
        toggleCategoryExpansion,
        clearFilters,
        handleRemove,
        selectedOptions,
        handleCheckboxChange,
        handleRemoveFilterOption,
        handleFilterOptionChange,
        filters,
        handleRadioFilterOptionChange,
        filtersReady,
        toggleCategorySelection,
        setFiltersReady
    };
}
export default useFilters;

